export default {
  created () {
    this.uuid = Math.random().toString(36).substring(3, 8)
  }
}



// WEBPACK FOOTER //
// ./~/_vux@2.9.0@vux/src/mixins/uuid.js